import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';
import { api } from '../services/api';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from './ui/use-toast';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (email.trim()) {
      setLoading(true);
      try {
        const response = await api.subscribeNewsletter(email);
        toast({
          title: 'Subscribed!',
          description: response.message || 'Thank you for subscribing to our newsletter.',
        });
        setEmail('');
      } catch (error) {
        console.error('Error subscribing:', error);
        toast({
          title: 'Error',
          description: 'Failed to subscribe. Please try again.',
          variant: 'destructive'
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200 mt-16">
      {/* Email subscription section */}
      <div className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="max-w-xl">
            <h3 className="text-2xl font-medium text-gray-900 mb-2">Join our email list</h3>
            <p className="text-gray-600 mb-6">Get exclusive deals and early access to new products.</p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <Input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                className="flex-1"
              />
              <Button 
                type="submit" 
                variant="outline" 
                className="px-6"
                disabled={loading}
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </Button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-4 text-sm text-gray-600">
            <span>© 2025 Edible Greetings by Potrait Chocolate</span>
            <Link to="/terms" className="hover:text-gray-900 transition-colors">
              Terms and Policies
            </Link>
          </div>
          <div className="flex items-center space-x-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors"
              aria-label="Facebook"
            >
              <Facebook className="h-5 w-5" />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      {/* Attribution */}
      <div className="bg-gray-50 py-4">
        <p className="text-center text-sm text-gray-600">
          Edible Greetings by Potrait Chocolate LLC
        </p>
      </div>
    </footer>
  );
};

export default Footer;
